import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import Uppy from '@uppy/core';
import { StatusBar } from '@uppy/react';
import { Button } from '@kajabi/sage-react';

import ImageEditor from './ImageEditor';

import './style.scss';

function ImageEditorPanel({ uppy, fileId, closeModal, ...rest }) {
  const [editorMode, setEditorMode] = useState(true);
  const [uploading, setUploading] = useState(false);
  const [saving, setSaving] = useState(false);
  const previewMode = !editorMode;

  useEffect(() => {
    const handleEditorComplete = () => {
      setSaving(false);
      setEditorMode(false);
    };

    uppy.on('file-editor:complete', handleEditorComplete);

    return () => { uppy.off('file-editor:complete', handleEditorComplete); };
  }, []);

  const handleSave = () => {
    setSaving(true);
    uppy.getPlugin('react:ImageEditor').save();
  };

  const handleReset = () => {
    setEditorMode(true);
  };

  const handleUpload = () => {
    setUploading(true);
    uppy.upload().then(closeModal);
  };

  return (
    <div className="kj-uploader-ImageEditorPanel">
      <div className="kj-uploader-ImageEditorPanel__bar">
        <Button
          color={Button.COLORS.PRIMARY}
          subtle={true}
          disabled={uploading || editorMode}
          onClick={handleReset}
        >
          Reset
        </Button>

        {editorMode && (
          <Button
            color={Button.COLORS.ACCENT}
            subtle={true}
            disabled={saving}
            onClick={handleSave}
          >
            Save
          </Button>
        )}

        {previewMode && (
          <Button
            color={Button.COLORS.ACCENT}
            subtle={true}
            disabled={uploading}
            onClick={handleUpload}
          >
            Upload
          </Button>
        )}
      </div>
      <div className="kj-uploader-ImageEditorPanel__body">
        <ImageEditor
          {...rest}
          uppy={uppy}
          currentFile={uppy.getFile(fileId)}
          isVisible={editorMode}
        />
        {previewMode && (
          <>
            <div className="kj-uploader-ImageEditorPanel__img-wrapper">
              <img
                src={URL.createObjectURL(uppy.getFile(fileId).data)}
                alt={uppy.getFile(fileId).name}
                className="kj-uploader-ImageEditorPanel__img"
              />
            </div>
            <StatusBar
              uppy={uppy}
              hidePauseResumeButton
              hideCancelButton
            />
          </>
        )}
      </div>
    </div>
  );
}

ImageEditorPanel.propTypes = {
  uppy: PropTypes.instanceOf(Uppy).isRequired,
  fileId: PropTypes.string.isRequired,
  closeModal: PropTypes.func
};

ImageEditorPanel.defaultProps = {
  closeModal: () => {}
};

export default ImageEditorPanel;
